// extracted by mini-css-extract-plugin
export default {"tableRow":"styles_tableRow__oe2qx","subtotal":"styles_subtotal__-8IwM"};